import { render, staticRenderFns } from "./AdmisionRegistroA.vue?vue&type=template&id=da7773d8"
import script from "./AdmisionRegistroA.vue?vue&type=script&lang=js"
export * from "./AdmisionRegistroA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports